export default __webpack_public_path__ + "static/media/deloitte-special-use-icon-font.5f5d4993.eot";